/* eslint-disable import/no-anonymous-default-export */
import { HTTP } from "api";

const basePath = "/dashboard";

export default {
  getDashboardData() {
    //return HTTP.get(basePath + '?projectId=' + projectId)
    return HTTP.get(basePath);
  },

  getPackagingData() {
    return localStorage.getItem("packaging");
    //return HTTP.get('../../mock/packaging.json')
  },
};
